import {Dispatchable} from "../../stem-core/src/base/Dispatcher";
import {BLINK_MESSAGE_IDENTIFIER, formatType} from "../../blink-sdk/messaging/IFrameMessages";

function dispatchWindowMessage(windowElement, type, data = {}) {
    windowElement.postMessage({
        ...data,
        type: formatType(type),
    }, "*");
}

class IFrameConnection extends Dispatchable {
    constructor() {
        super();

        this.attachEventListener(window, "message", event => {
            let {data} = event;

            if (typeof data !== "object") {
                return;
            }

            data.eventOrigin = event.origin;
            const {type} = data;

            if (!(typeof type === "string" || type instanceof String) || !type.startsWith(BLINK_MESSAGE_IDENTIFIER)) {
                return;
            }

            this.dispatch(type.substring(BLINK_MESSAGE_IDENTIFIER.length), data);
        });
    }

    sendToSDK(type, data = {}) {
        dispatchWindowMessage(window.parent, type, data);
    }

    sendToOpener(type, data = {}) {
        dispatchWindowMessage(window.opener, type, data);
    }

    // This method is used for sending messages from an iframe to the others, this is useful for manual confirmed
    // payments and token sharing between iframes when the user has third party storage disabled.
    sendToIFrames(type, data={}) {
        const {frames} = window.parent;
        for (let index = 0; index < frames.length; index += 1) {
            try {
                const frame = frames[index];
                if (frame !== window && frame.origin === window.origin) {
                    dispatchWindowMessage(frame, type, data);
                }
            } catch (e) {}
        }
    }

    addIframesListener(type, callback) {
        return this.addListener(type, (event, ...args) => {
            // This callback is intended to be called only if the message dispatched comes from another of our iframes.
            if (event.eventOrigin !== window.origin) {
                return;
            }
            callback(event, ...args);
        });
    }
}

export const iFrameConnection = new IFrameConnection();
